var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOvalSeccao19(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.88 199.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n     #bg-section-19 .cls-1 {\r\n        fill: #fff;\r\n        opacity: 0.5;\r\n        isolation: isolate;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bg-section-19",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "oval-seccao-19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    className: "cls-1 rotate-center",
    d: "M175.1,179.38a63.39,63.39,0,0,1-9,4.74h0s-51.43,24.39-113.25,11.07h0A63.42,63.42,0,0,1,9.78,166.11a64.52,64.52,0,0,1-7.31-51.84C17.25,52.43,61.05,16.18,61.31,16a63.4,63.4,0,0,1,81.92-1.78s34,25.68,57.07,86.94h0A64.58,64.58,0,0,1,175.1,179.38Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvalSeccao19);
export default __webpack_public_path__ + "static/media/oval-seccao-19.bfe3227ad41337c23598208188dc2110.svg";
export { ForwardRef as ReactComponent };